import React from 'react';
import { ExercisesQuestionsInteractive } from './exercises-questions-interactive';
import { IconVerified } from '@/components/custom/icon';
import { Badge, BadgeGroup } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { QuestionCard, QuestionCardIntroduction, QuestionCardPrint } from '@/components/custom/question';

export function ExercisesQuestionsCard(props) {
  const { groupedQuestion, taxonomyIds, setTaxonomyIds, updateLastAnswerSubmited } = props;

  const introduction = groupedQuestion[0]?.introduction?.body || groupedQuestion[0]?.['motivator-texts']?.[0]?.body;

  const setFilterTaxonomy = taxonomyId => {
    if (props.taxonomyIds.length === 1 && props.taxonomyIds.includes(taxonomyId)) {
      props.setTaxonomyIds([]);
    } else {
      props.setTaxonomyIds([taxonomyId]);
    }
  };

  return (
    <QuestionCard>
      <div className="mb-4 flex items-center gap-2">
        <Badge
          variant="bright"
          square
          size="xs"
        >
          Q{groupedQuestion[0]?.id}
        </Badge>
        {groupedQuestion[0]?.['official-content'] === true && <IconVerified />}
      </div>

      <BadgeGroup className="mb-4 w-full">
        {groupedQuestion[0]?.taxonomies?.map(
          (taxonomy, index) =>
            index < 6 && (
              <Button
                key={`${index}-${taxonomy.id}`}
                variant="primary-light"
                size="xs"
                onClick={() => setFilterTaxonomy(taxonomy.id)}
              >
                {taxonomy.name}
              </Button>
            )
        )}
      </BadgeGroup>

      <QuestionCardIntroduction dangerouslySetInnerHTML={{ __html: introduction }} />

      <QuestionCardPrint dangerouslySetInnerHTML={{ __html: groupedQuestion[0]?.['motivator-texts']?.[0]?.print }} />

      {groupedQuestion?.map(question => (
        <ExercisesQuestionsInteractive
          key={question?.id}
          question={question}
          taxonomyIds={taxonomyIds}
          setTaxonomyIds={setTaxonomyIds}
          updateLastAnswerSubmited={updateLastAnswerSubmited}
        />
      ))}
    </QuestionCard>
  );
}
